import { render, staticRenderFns } from "./Tag2.vue?vue&type=template&id=6648164a&scoped=true"
import script from "./Tag2.vue?vue&type=script&lang=js"
export * from "./Tag2.vue?vue&type=script&lang=js"
import style0 from "./Tag2.vue?vue&type=style&index=0&id=6648164a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6648164a",
  null
  
)

export default component.exports